module.exports = __webpack_public_path__ + "static/media/l8.58d1b4fb.jpg";